import React,{useState} from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { IAppPropsWithRoute } from '../../../common/types';

import {
    Box, Grid,
    Button, IconButton,
    TextField, Select, MenuItem,
    FormHelperText, FormControl, FormControlLabel,
    RadioGroup, Radio, Checkbox, InputAdornment
} from '@material-ui/core';
import { useStyles } from "../styles";
import * as Icons from "../iconComponents";
import { useFormContext, Controller } from "react-hook-form";
import IndexedDb from '../IndexedDb';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Dialog from "@material-ui/core/Dialog";
import { format } from 'date-fns';
import moment from 'moment'
import { da } from 'date-fns/locale';
import { datePickerDefaultProps } from '@material-ui/pickers/constants/prop-types';
import { time, timeStamp } from 'console';
import GooglePlaceAutoComplete from '../GooglePlaceAutoComplete';
import { times } from 'lodash';
import TimeInput from '../../ui/TimeInput';


interface PcrWidgetProps extends IAppPropsWithRoute {

};

const SubFormWidget: React.FC<PcrWidgetProps> = () => {
    const classes = useStyles();
    const history = useHistory();
    const [uname, setname] = useState(" ");
    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useFormContext();
    const pcrType = watch("pcr_type");
    const handoverSetting = watch("handover_setting");
    const[Indexdb,setIndexdb]=useState("");
    
    const [Handoverlocation, setHandoverlocation] = useState("");
    const [Handoversetting, setHandoversetting] = useState(0);
    const [Handovername, setHandovername] = useState("");
    const [Handoverrole, setHandoverrole] = useState("");
    const [Ambulancenumber, setAmbulancenumber] = useState("");
    const [Handoverdate, setHandoverdate] = useState<Date>();
    const [Handovertime, setHandovertime] = useState<Date>();
    const [Ambulancecalleddate, setAmbulancecalleddate] = useState<Date>();
    const [Ambulancecalledtime, setAmbulancecalledtime] = useState<Date>();
    const [Ambulanceonsitedate, setAmbulanceonsitedate] = useState<Date>();
    const [Ambulanceonsitetime, setAmbulanceonsitetime] = useState<Date>();
    const [Ambulancedeptdate, setAmbulancedeptdate] = useState<Date>();
    const [Ambulancedepttime, setAmbulancedepttime] = useState<Date>();

    React.useEffect(() => {
        let db:any = null;
        db = localStorage.getItem("PatientDB");
        setIndexdb(db);
        getindexdbvalues();
    }, [])
    const getindexdbvalues = async (): Promise<void> => {
        let db:any = null;
        let date:Date=new Date();
        let observationdata = null ;
        db = localStorage.getItem("PatientDB");
        if(db!=null && db !="")
        {
        const indexedDb = new IndexedDb(db);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        let val = await indexedDb.getAllValue('Handover');
        for(let i=0;i<val.length;i++)
        {
            if(val[i].Key == "Handoversetting")
            {
                setValue("handover_setting",val[i].value.column);
            }
            if(val[i].Key == "Handoverlocation")
            {
                setHandoverlocation(val[i].value.column);
                setValue("handover_location",val[i].value.column)
                //setname(val[i].value.column);
            }
            if(val[i].Key == "Handovername")
            {
                setHandovername(val[i].value.column);
                setValue("handover_name",val[i].value.column)
            }
            if(val[i].Key == "Handoverrole")
            {
                //
                setHandoverrole(val[i].value.column);
                setValue("handover_role",val[i].value.column)
            }
            if(val[i].Key == "Ambulancenumber")
            {
                setValue("ambulance_number",val[i].value.column)
                setAmbulancenumber(val[i].value.column);
            }
            if(val[i].Key == "Handoverdate")
            {
                //const [day,month,year] = val[i].value.column.split('/');
                var dates =(val[i].value.column);             
                setHandoverdate(dates);   
                setValue("handover_date",dates)  
                //setValue("handover_date",dates)                     
            }
            if(val[i].Key == "Handovertime")
            {   
                //const [H,M,S] = val[i].value.column.split(':');
                var time =(val[i].value.column);
                setHandovertime(time);  
                setValue("handover_time",time)
                //setValue("handover_time",time)   
            }
            if(val[i].Key == "Ambulancecalleddate")
            {
                var dates = (val[i].value.column);              
                setAmbulancecalleddate(dates);      
            }
            if(val[i].Key == "Ambulancecalledtime")
            {
                var time = (val[i].value.column);
                setAmbulancecalledtime(time);   
            }
            if(val[i].Key == "Ambulanceonsitedate")
            {
                var dates = (val[i].value.column);               
                setAmbulanceonsitedate(dates);      
            }
            if(val[i].Key == "Ambulanceonsitetime")
            {
                var time =(val[i].value.column);
                setAmbulanceonsitetime(time);     
            }
            if(val[i].Key == "Ambulancedeptdate")
            {
                var dates = (val[i].value.column);            
                setAmbulancedeptdate(dates);
            }
            if(val[i].Key == "Ambulancedepttime")
            {
                var time = (val[i].value.column);
                setAmbulancedepttime(time);     
            }
        }
        }      
    }
    const [selectedDate, setSelectedDate] = useState(new Date());
    const handleDateChange = (date:any,Key:any) => {
        if(Key == "Handoverdate")
        {
            setHandoverdate(date);
            setValue("handover_date",date)
        }
        if(Key == "Handovertime")
        {
            setHandovertime(date);
            setValue("handover_time",date)
        }
        if(Key == "Ambulancecalleddate")
        {
            setAmbulancecalleddate(date);
        }
        if(Key == "Ambulancecalledtime")
        {
            setAmbulancecalledtime(date);
        }
        if(Key == "Ambulanceonsitedate")
        {
            setAmbulanceonsitedate(date);
        }
        if(Key == "Ambulanceonsitetime")
        {
            setAmbulanceonsitetime(date);
        }
        if(Key == "Ambulancedeptdate")
        {
            setAmbulancedeptdate(date);
        }
        if(Key == "Ambulancedepttime")
        {
            setAmbulancedepttime(date);
        }
        
      };
    const handleindexdbsave = async (Key:any,value:any): Promise<void> => {       
        let values = getValues();             
        if(Indexdb!=null || Indexdb !="")
        {
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            await indexedDb.deleteValue('Handover', Key);
            await indexedDb.putValue('Handover', { column:value !== undefined?value:null,Patid:0 },Key);
        }    
    }
    const handleChange = (e:any) => {
        //console.log(e.target.value);
        setHandoversetting(e.target.value);
      };
    const validateName =async () => {       
        var s = getValues("handover_name");
        if(s == "")
        {
            return 'Handover Name is required';
        }
      };
      const validateRole =async () => {       
        var s = getValues("handover_role");
        if(s == "")
        {
            return 'Handover Role is required';
        }
      };
      const validateAmbulanceno =async () => {       
        var s = getValues("ambulance_number");
        if(s == "")
        {
            return 'Ambulance Number is required';
        }
      };
    return (
        <div>
            <div className={classes.pcrAddTabHeading}>
                <div>
                    Handover
                </div>
            </div>
            <Grid container className={classes.formContainer} spacing={3}>

                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        <Icons.RequiredIcon />SETTING
                    </div>
                    <Controller
                        control={control}
                        name="handover_setting"
                        defaultValue={Handoversetting}
                        render={({ name, onBlur, onChange, value }) => (
                            <>
                                <FormControl fullWidth error={errors.handover_setting}>
                                    <RadioGroup
                                        value={value}                                
                                        //defaultValue={Handoversetting}                                        
                                        onChange={(e: any) => { onChange(e,handleindexdbsave('Handoversetting',e.target.value) ) }}
                                    >
                                        <FormControlLabel
                                            value="1"                                                                                 
                                            control={<Radio />}
                                            label="Patient handed over to ambulance"
                                        />
                                        <FormControlLabel
                                            value="2"                                                                                      
                                            control={<Radio />}
                                            label="Patient handed over to medical facility"
                                        />
                                        <FormControlLabel
                                            value="3"                                                                                      
                                            control={<Radio />}
                                            label="Patient taken into their own care (SMA care complete)"
                                        />
                                        <FormControlLabel
                                            value="4"                                                                                      
                                            control={<Radio />}
                                            label="Patient taken into their own care (SMA care refused)"
                                        />
                                        <FormControlLabel
                                            value="5"                                                                                        
                                            control={<Radio />}
                                            label="Other"
                                        />
                                    </RadioGroup>
                                    <FormHelperText>{errors.handover_setting ? errors.handover_setting.message : ""}</FormHelperText>
                                </FormControl>
                            </>
                        )}
                        rules={{
                            required: "Setting is required",
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <div style={{ borderBottom: '2px solid #FFFFFF', margin: '16px 0px 8px 0px' }}></div>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        <Icons.RequiredIcon />HANDOVER LOCATION
                    </div>
                    <Controller
                        name='handover_location'
                        defaultValue=''
                        control={control}
                        render={({ onChange, onBlur, value }) => {
                            return (
                                <>
                                <GooglePlaceAutoComplete
                                    placeholder=''
                                    onInputChange={(value: string) => {
                                        onChange(value);
                                        onBlur();
                                        handleindexdbsave('Handoverlocation', value);
                                        setHandoverlocation(value);
                                    }}
                                    onChange={(value: any) => {
                                        if (value) {
                                            handleindexdbsave('Handoverlocationgoogleplaceid', value.place_id);
                                        }
                                    }}
                                    value={''}
                                    inputValue={value}
                                    singleLine={true}
                                    hideNoOption={true}
                                    error={errors.handover_location}
                                    // errorMessage={errors.handover_location ? errors.handover_location.message : ''}
                                />
                                {errors.handover_location && (
                                <FormHelperText style={{color:"red"}}>{errors.handover_location ? errors.handover_location.message : ""}</FormHelperText> 
                                )}
                                </>
                            );
                        }}
                        rules={{
                            validate: (value) => {
                                if (value === '') {
                                    return "Handover Location is required";
                                }
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        <Icons.RequiredIcon />HANDOVER DATE & TIME (24 HOUR)
                    </div>
                    <Grid container spacing={3}>
                        <Grid item xs={6} sm={3}>
                            <Controller
                                control={control}
                                name="handover_date"
                                defaultValue={Handoverdate !=null?Handoverdate:null}
                                render={({ onChange, onBlur, value, name }) => (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            inputVariant="outlined"
                                            //label="Material Date Picker"
                                            value={Handoverdate || null}
                                            format="dd/MM/yyyy"
                                            placeholder="DD/MM/YYYY"
                                            cancelLabel={false}
                                            okLabel={false}
                                            autoOk={true}
                                            onChange={(e) =>{ 
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Handoverdate");
                                                            setValue("handover_date",e);  handleindexdbsave('Handoverdate',timestamp);
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Handoverdate");
                                                        setValue("handover_date",e);  handleindexdbsave('Handoverdate',null);
                                                    }                                                                                                
                                                }
                                                
                                            }}
                                            onFocusCapture={(e) =>
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Handoverdate");
                                                            setValue("handover_date",e);  handleindexdbsave('Handoverdate',timestamp);
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Handoverdate");
                                                        setValue("handover_date",e);  handleindexdbsave('Handoverdate',null);
                                                    }                                                                                                
                                                }
                                            }
                                            InputProps={{ classes: { root: classes.textFieldInput } }}
                                            error={errors.handover_date}
                                            helperText={errors.handover_date ? errors.handover_date.message : ""}    
                                            keyboardIcon={<Icons.DatePickerIcon />}
                                        />
                                    </MuiPickersUtilsProvider>
                                )}
                                rules={{
                                    required: "Handover Date  is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Controller
                                control={control}
                                name="handover_time"
                              
                                render={({ onChange, onBlur, value, name }) => (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <TimeInput
                                            inputVariant="outlined"
                                            //label="Material Date Picker"
                                            value={Handovertime || null}
                                            format="HH:mm"
                                            placeholder="HH:MM"
                                            cancelLabel={false}
                                            okLabel={false}
                                            autoOk={true}                                  
                                            onChange={(e) => {
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Handovertime");
                                                            setValue("handover_time",e); handleindexdbsave('Handovertime',timestamp) ;
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Handovertime");
                                                        setValue("handover_time",e); handleindexdbsave('Handovertime',null) ;
                                                    }                                                                                                
                                                }
                                                }}
                                            //inputProps={{ classes: { root: classes.textFieldInput } }}
                                            onFocusCapture={(e) =>
                                                handleindexdbsave('Handovertime',Handovertime) 
                                            }
                                            InputProps={{ classes: { root: classes.textFieldInput } }}
                                            error={errors.handover_time}
                                            helperText={errors.handover_time ? errors.handover_time.message : ""}
                                            keyboardIcon={<Icons.TimePickerIcon />}
                                        />
                                    </MuiPickersUtilsProvider>
                                )}
                                rules={{
                                    required: "Handover Time is required",
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12}></Grid>
                
                {(handoverSetting === "1") && (<>
                <Grid item xs={12} sm={12}>
                    <div style={{ borderBottom: '2px solid #F3F4F5', margin: '0px 0px 8px 0px' }}></div>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        <Icons.RequiredIcon />AMBULANCE NUMBER
                    </div>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Controller
                                control={control}
                                defaultValue={Ambulancenumber}
                                name="ambulance_number"
                                render={({ onChange, onBlur, value, name }) => (
                                    <>
                                    <TextField
                                        variant="outlined"
                                        value={Ambulancenumber}
                                        onChange={e => {
                                            onChange(e.target.value);
                                            setAmbulancenumber(e.target.value)
                                        }}
                                        InputProps={{ classes: { root: classes.textFieldInput } }}
                                        inputProps={{ maxLength: 200, minLength: 0,autocomplete:'disabled' }}
                                        onBlur={e => {
                                            handleindexdbsave('Ambulancenumber', e.target.value);
                                        }}                                       
                                        //error={Boolean(errors.ambulance_number)}
                                    />
                                    {errors.ambulance_number && (
                                    <FormHelperText style={{color:"red"}}>{errors.ambulance_number ? errors.ambulance_number.message : ""}</FormHelperText>
                                    )}
                                    </>
                                )}
                                rules={{
                                    validate:validateAmbulanceno
                                   // required: "Ambulance Number is required",
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        DATE/TIME AMBULANCE CALLED
                    </div>
                    <Grid container spacing={3}>
                        <Grid item xs={6} sm={3}>
                            <Controller
                                control={control}
                                name="ambulance_called_date"
                                defaultValue={Ambulancecalleddate !=null ?Ambulancecalleddate:null}
                                render={props => (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            inputVariant="outlined"
                                            //label="Material Date Picker"
                                            value={Ambulancecalleddate || null}
                                            format="dd/MM/yyyy"
                                            placeholder="DD/MM/YYYY"
                                            cancelLabel={false}
                                            okLabel={false}
                                            autoOk={true}
                                            defaultValue={Ambulancecalleddate}
                                            onChange={(e) =>{
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Ambulancecalleddate");
                                                            handleindexdbsave('Ambulancecalleddate',timestamp)
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Ambulancecalleddate");
                                                     handleindexdbsave('Ambulancecalleddate',null)
                                                    }                                                                                                
                                                }
                                                }}
                                            //inputProps={{ classes: { root: classes.textFieldInput } }}
                                            onFocusCapture={(e) =>
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Ambulancecalleddate");
                                                            handleindexdbsave('Ambulancecalleddate',timestamp)
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Ambulancecalleddate");
                                                     handleindexdbsave('Ambulancecalleddate',null)
                                                    }                                                                                                
                                                }
                                            }
                                            InputProps={{ classes: { root: classes.textFieldInput } }}
                                            error={errors.ambulance_departede_time}
                                            helperText={errors.ambulance_departede_time ? errors.ambulance_departede_time.message : ""}
                                            keyboardIcon={<Icons.DatePickerIcon />}
                                        />
                                    </MuiPickersUtilsProvider>
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Controller
                                control={control}
                                name="ambulance_called_time"
                                render={props => (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <TimeInput
                                            inputVariant="outlined"
                                            //label="Material Date Picker"
                                            value={Ambulancecalledtime || null}
                                            format="HH:mm"
                                            placeholder="HH:MM"
                                            cancelLabel={false}
                                            okLabel={false}
                                            autoOk={true}                                  
                                            onChange={(e) => {
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Ambulancecalledtime");
                                                            handleindexdbsave('Ambulancecalledtime',timestamp)
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Ambulancecalledtime");
                                                        handleindexdbsave('Ambulancecalledtime',null)
                                                    }                                                                                                
                                                }
                                               }}
                                            //inputProps={{ classes: { root: classes.textFieldInput } }}
                                            onFocusCapture={(e) =>
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Ambulancecalledtime");
                                                            handleindexdbsave('Ambulancecalledtime',timestamp)
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Ambulancecalledtime");
                                                        handleindexdbsave('Ambulancecalledtime',null)
                                                    }                                                                                                
                                                }
                                            }
                                            InputProps={{ classes: { root: classes.textFieldInput } }}
                                            error={errors.ambulance_departede_time}
                                            helperText={errors.ambulance_departede_time ? errors.ambulance_departede_time.message : ""}
                                            keyboardIcon={<Icons.TimePickerIcon />}
                                        />
                                    </MuiPickersUtilsProvider>
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        DATE/TIME AMBULANCE ON SITE
                    </div>
                    <Grid container spacing={3}>
                        <Grid item xs={6} sm={3}>
                            <Controller
                                control={control}
                                name="ambulance_onsite_date"
                                defaultValue={Ambulanceonsitedate !=null ? Ambulanceonsitedate:null}
                                render={props => (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            inputVariant="outlined"
                                            //label="Material Date Picker"
                                            value={Ambulanceonsitedate||null}
                                            format="dd/MM/yyyy"
                                            placeholder="DD/MM/YYYY"
                                            cancelLabel={false}
                                            okLabel={false}
                                            autoOk={true}
                                            onChange={(e) => {
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Ambulanceonsitedate"); handleindexdbsave('Ambulanceonsitedate',timestamp)
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Ambulanceonsitedate"); handleindexdbsave('Ambulanceonsitedate',null)
                                                    }                                                                                                
                                                }
                                               }}
                                            defaultValue={Ambulanceonsitedate}
                                            //inputProps={{ classes: { root: classes.textFieldInput } }}
                                            onFocusCapture={(e) =>
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Ambulanceonsitedate"); handleindexdbsave('Ambulanceonsitedate',timestamp)
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Ambulanceonsitedate"); handleindexdbsave('Ambulanceonsitedate',null)
                                                    }                                                                                                
                                                }
                                            }
                                            InputProps={{ classes: { root: classes.textFieldInput } }}
                                            error={errors.ambulance_departede_time}
                                            helperText={errors.ambulance_departede_time ? errors.ambulance_departede_time.message : ""}
                                            keyboardIcon={<Icons.DatePickerIcon />}
                                        />
                                    </MuiPickersUtilsProvider>
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Controller
                                control={control}
                                name="ambulance_onsite_time"
                                render={props => (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <TimeInput
                                            inputVariant="outlined"
                                            //label="Material Date Picker"
                                            value={Ambulanceonsitetime||null}
                                            format="HH:mm"
                                            placeholder="HH:MM"
                                            cancelLabel={false}
                                            okLabel={false}
                                            autoOk={true}                                  
                                            onChange={(e) => {
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Ambulanceonsitetime"); handleindexdbsave('Ambulanceonsitetime',timestamp)
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Ambulanceonsitetime"); handleindexdbsave('Ambulanceonsitetime',null)
                                                    }                                                                                                
                                                }
                                              }}
                                            //inputProps={{ classes: { root: classes.textFieldInput } }}
                                            onFocusCapture={(e) =>
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Ambulanceonsitetime"); handleindexdbsave('Ambulanceonsitetime',timestamp)
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Ambulanceonsitetime"); handleindexdbsave('Ambulanceonsitetime',null)
                                                    }                                                                                                
                                                }
                                            }
                                            InputProps={{ classes: { root: classes.textFieldInput } }}
                                            error={errors.ambulance_departede_time}
                                            helperText={errors.ambulance_departede_time ? errors.ambulance_departede_time.message : ""}
                                            keyboardIcon={<Icons.TimePickerIcon />}
                                        />
                                    </MuiPickersUtilsProvider>
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        DATE/TIME AMBULANCE DEPARTED
                    </div>
                    <Grid container spacing={3}>
                        <Grid item xs={6} sm={3}>
                            <Controller
                                control={control}
                                name="ambulance_departede_date"
                                defaultValue={Ambulancedeptdate !=null ? Ambulancedeptdate :null}
                                render={props => (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            inputVariant="outlined"
                                            //label="Material Date Picker"
                                            value={Ambulancedeptdate||null}
                                            format="dd/MM/yyyy"
                                            placeholder="DD/MM/YYYY"
                                            cancelLabel={false}
                                            okLabel={false}
                                            autoOk={true}
                                            onChange={(e) => {
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Ambulancedeptdate"); handleindexdbsave('Ambulancedeptdate',timestamp)
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Ambulancedeptdate"); handleindexdbsave('Ambulancedeptdate',null)
                                                    }                                                                                                
                                                }
                                            }}
                                            defaultValue={Ambulancedeptdate}
                                            //inputProps={{ classes: { root: classes.textFieldInput } }}
                                            onFocusCapture={(e) =>
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Ambulancedeptdate"); handleindexdbsave('Ambulancedeptdate',timestamp)
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Ambulancedeptdate"); handleindexdbsave('Ambulancedeptdate',null)
                                                    }                                                                                                
                                                }
                                            }
                                            InputProps={{ classes: { root: classes.textFieldInput } }}
                                            error={errors.ambulance_departede_time}
                                            helperText={errors.ambulance_departede_time ? errors.ambulance_departede_time.message : ""}
                                            keyboardIcon={<Icons.DatePickerIcon />}
                                        />
                                    </MuiPickersUtilsProvider>
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Controller
                                control={control}
                                name="ambulance_departede_time"
                                render={props => (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <TimeInput
                                            inputVariant="outlined"
                                            //label="Material Date Picker"
                                            value={Ambulancedepttime || null}
                                            format="HH:mm"
                                            placeholder="HH:MM"
                                            cancelLabel={false}
                                            okLabel={false}
                                            autoOk={true}                                  
                                            onChange={(e) => {
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Ambulancedepttime");handleindexdbsave('Ambulancedepttime',timestamp)
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Ambulancedepttime");handleindexdbsave('Ambulancedepttime',null)
                                                    }                                                                                                
                                                }
                                           }}
                                            //inputProps={{ classes: { root: classes.textFieldInput } }}
                                            onFocusCapture={(e) =>
                                                {                                                
                                                    if(e !== null)
                                                    {
                                                        let timestamp = Date.parse(e.toString());
                                                         if (!isNaN(timestamp)) {
                                                            handleDateChange(e, "Ambulancedepttime");handleindexdbsave('Ambulancedepttime',timestamp)
                                                          }                                                           
                                                    }
                                                    else
                                                    {
                                                        handleDateChange(e, "Ambulancedepttime");handleindexdbsave('Ambulancedepttime',null)
                                                    }                                                                                                
                                                }
                                                }
                                            InputProps={{ classes: { root: classes.textFieldInput } }}
                                            error={errors.ambulance_departede_time}
                                            helperText={errors.ambulance_departede_time ? errors.ambulance_departede_time.message : ""}
                                            keyboardIcon={<Icons.TimePickerIcon />}
                                        />
                                    </MuiPickersUtilsProvider>
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                </>)}
                
                {(handoverSetting === "2") && (<>
                <Grid item xs={12} sm={12}>
                    <div style={{ borderBottom: '2px solid #F3F4F5', margin: '0px 0px 8px 0px' }}></div>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        Handed over to:
                    </div>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <div className={classes.formControlLabel}>
                                <Icons.RequiredIcon />NAME
                            </div>
                            <Controller
                                control={control}
                                name="handover_name"
                                defaultValue={Handovername}
                                render={({ onChange, onBlur, value, name }) => (
                                    <TextField
                                        variant='outlined'
                                        value={Handovername}
                                        onChange={e => {
                                            onChange(e)                                          
                                            setHandovername(e.target.value)
                                        }}
                                        //defaultValue={Handovername}
                                        InputProps={{ classes: { root: classes.textFieldInput } }}
                                        inputProps={{ maxLength: 200, minLength: 0,autocomplete:'disabled' }}
                                        error={errors.handover_name} helperText={errors.handover_name ? errors.handover_name.message : ""}
                                        onBlur={(e) =>
                                            handleindexdbsave('Handovername',e.target.value) 
                                            }
                                            required
                                    />
                                )}
                                rules={{
                                    validate:validateName
                                    //required: "Handover Name field is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className={classes.formControlLabel}>
                                <Icons.RequiredIcon />ROLE
                            </div>
                            <Controller
                                control={control}
                                name="handover_role"
                                defaultValue={Handoverrole}
                                render={({ onChange, onBlur, value, name }) => (
                                    <TextField
                                        variant='outlined'
                                        value={Handoverrole}
                                        onChange={e => {
                                            onChange(e)
                                            setHandoverrole(e.target.value)
                                        }}
                                        //defaultValue={uname}
                                        InputProps={{ classes: { root: classes.textFieldInput } }}
                                        inputProps={{ maxLength: 200, minLength: 0,autocomplete:'disabled' }}
                                        required                               
                                        error={errors.handover_role} helperText={errors.handover_role  ? errors.handover_role.message : ""}
                                        onBlur={(e) =>
                                            handleindexdbsave('Handoverrole',e.target.value) 
                                            }
                                    />
                                )}
                                rules={{
                                    validate:validateRole
                                    //required: "Handover Role field is required",
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                </>)}

            </Grid>
        </div>
    );
}

export default React.memo(withRouter(SubFormWidget));